import '../../style/base.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/swipe-item/style/index.js
// module id = 103
// module chunks = 31